const SIZE_OPTION_NAMES = ['size', 'størrelse', 'storlek', 'størelse', 'größe', 'taille'];

class CustomSizeChartDrawer extends HTMLElement {
  constructor() {
    super();

    this.triggerSelector = `[data-size-chart-trigger="${this.dataset.productId}"]`;
    this.activeElement = null;

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    const overlay = this.querySelector('.custom-size-chart-drawer__overlay');
    if (overlay) overlay.addEventListener('click', () => this.close());

    const closeBtn = this.querySelector('.custom-size-chart-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
  }

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    document.querySelectorAll(this.triggerSelector).forEach((trigger) => {
      this.portalTrigger(trigger);
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
    });
  }

  portalTrigger(trigger) {
    const legend = this.findSizeLegend();
    if (!legend || legend.contains(trigger)) return;

    legend.classList.add('form__label--with-size-chart');
    legend.appendChild(trigger);
  }

  findSizeLegend() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return null;

    const legends = variantSelects.querySelectorAll('legend.form__label, label.form__label');
    for (const legend of legends) {
      const text = (legend.textContent || '').trim().toLowerCase();
      if (SIZE_OPTION_NAMES.some((name) => text.startsWith(name))) {
        return legend;
      }
    }
    return null;
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    requestAnimationFrame(() => {
      this.classList.add('active');
    });

    const focusTarget = this.querySelector('.custom-size-chart-drawer__close');
    const container = this.querySelector('.custom-size-chart-drawer__inner');

    this.addEventListener(
      'transitionend',
      () => {
        if (typeof trapFocus === 'function' && container) {
          trapFocus(container, focusTarget || container);
        } else if (focusTarget) {
          focusTarget.focus();
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('custom-size-chart-drawer', CustomSizeChartDrawer);
